<script src="../../crazy-item-page.component.ts"></script>
<ds-metadata-field-wrapper [label]="label | translate">
    <div *ngVar="(originals$ | async)?.payload as originals">
        <div *ngIf="hasValuesInBundle(originals)">
            <h5 class="simple-view-element-header">{{"item.page.filesection.original.bundle" | translate}}</h5>
            <ds-pagination *ngIf="originals?.page?.length > 0"
                           [hideGear]="true"
                           [hidePagerWhenSinglePage]="true"
                           [paginationOptions]="originalOptions"
                           [collectionSize]="originals?.totalElements"
                           [retainScrollPosition]="true">


                <div class="file-section row mb-3" *ngFor="let file of originals?.page;">
                    <div class="col-3">
                        <ds-thumbnail [thumbnail]="(file.thumbnail | async)?.payload"></ds-thumbnail>
                    </div>
                    <div class="col-9">
                        <dl class="row">
                            <dt class="col-md-4">{{"item.page.filesection.name" | translate}}</dt>
                            <dd class="col-md-8">
                              <ds-themed-file-download-link [bitstream]="file" [item]="item">
                                {{file.firstMetadataValue("dc.title")}}
                              </ds-themed-file-download-link>
                            </dd>



                            <dt class="col-md-4">{{"item.page.filesection.size" | translate}}</dt>
                            <dd class="col-md-8">{{(file.sizeBytes) | dsFileSize }}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.format" | translate}}</dt>
                            <dd class="col-md-8">{{(file.format | async)?.payload?.description}}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.description" | translate}}</dt>
                            <dd class="col-md-8">{{file.firstMetadataValue("dc.description")}}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.uuid" | translate}}</dt>
                            <dd class="col-md-8">{{file.uuid}}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.source" | translate}}</dt>
                            <dd class="col-md-8">{{file.firstMetadataValue("dc.source")}}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.sequenceId" | translate}}</dt>
                            <dd class="col-md-8">{{ file.sequenceId }}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.hashValue" | translate}}</dt>
                            <dd class="col-md-8">({{ file.checkSum.checkSumAlgorithm }}) {{ file.checkSum.value }}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.deleted" | translate}}</dt>
                            <dd class="col-md-8">{{ file.deleted }}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.storeNumber" | translate}}</dt>
                            <dd class="col-md-8">{{  file.storeNumber }}</dd>
                        </dl>
                    </div>
                </div>
            </ds-pagination>
        </div>
    </div>
    <div *ngVar="(licenses$ | async)?.payload as licenses">
        <div *ngIf="hasValuesInBundle(licenses)">
            <h5 class="simple-view-element-header">{{"item.page.filesection.license.bundle" | translate}}</h5>
            <ds-pagination *ngIf="licenses?.page?.length > 0"
                           [hideGear]="true"
                           [hidePagerWhenSinglePage]="true"
                           [paginationOptions]="licenseOptions"
                           [collectionSize]="licenses?.totalElements"
                           [retainScrollPosition]="true">


                <div class="file-section row" *ngFor="let file of licenses?.page;">
                    <div class="col-3">
                        <ds-thumbnail [thumbnail]="(file.thumbnail | async)?.payload"></ds-thumbnail>
                    </div>
                    <div class="col-9">
                        <dl class="row">
                            <dt class="col-md-4">{{"item.page.filesection.name" | translate}}</dt>
                            <dd class="col-md-8">
                              <ds-themed-file-download-link [bitstream]="file" [item]="item">
                                {{file.firstMetadataValue("dc.title")}}
                              </ds-themed-file-download-link>
                            </dd>

                            <dt class="col-md-4">{{"item.page.filesection.size" | translate}}</dt>
                            <dd class="col-md-8">{{(file.sizeBytes) | dsFileSize }}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.format" | translate}}</dt>
                            <dd class="col-md-8">{{(file.format | async)?.payload?.description}}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.description" | translate}}</dt>
                            <dd class="col-md-8">{{file.firstMetadataValue("dc.description")}}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.uuid" | translate}}</dt>
                            <dd class="col-md-8">{{file.uuid}}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.source" | translate}}</dt>
                            <dd class="col-md-8">{{file.firstMetadataValue("dc.source")}}</dd>
                        </dl>
                    </div>
                </div>
            </ds-pagination>
        </div>
    </div>
</ds-metadata-field-wrapper>
